require("slick-carousel");

$(document).ready(function () {
    /*  $(".add-event").on("click", function() {
        const data = {
            event: $(this).data("evento"),
            project: $(this).data("proyecto")
        };
        axios.post("/add-event", data);
    }); */

    const carga = el => {
        el.addClass("cargado");
    };

    $(window).on("scroll", () => {
        var $maxScroll = $(window).height() + 100;
        var $maxScale = 1.5;
        var $x = $(window).scrollTop() / 1500 + 1;
        var $o = 1 - $(window).scrollTop() / 1100;
        if ($(window).scrollTop() > $maxScroll) $x = $maxScale;
        if ($o <= 0) {
            $o = 0;
        }
        $("#hero .background").css({
            transform: "scale(" + $x + "," + $x + ")",
            opacity: $o
        });

        if ($(window).scrollTop() >= 50) {
            $("header").addClass("scroll");
        } else {
            $("header").removeClass("scroll");
        }

        /* if (
            $(window).scrollTop() >=
                $(".espacios").offset().top - $(window).height() / 2 &&
            !$(".ambiente").hasClass("cargado")
        ) {
            carga($(".espacios"));
            $(".espacios .container").slideDown();
        }

        if (
            $(window).scrollTop() >=
                $(".caracteristicas").offset().top - $(window).height() / 2 &&
            !$(".caracteristicas").hasClass("cargado")
        ) {
            carga($(".caracteristicas"));
        }

        if (
            $(window).scrollTop() >=
            $(".disenio").offset().top - $(window).height() / 2
        ) {
            $(".disenio .contenido").slideDown();
        } */

        // $(".parallax").paroller();
    });

    /* $("header").slideDown(() => {
        $(".hero .container").fadeIn();
    }); */

    $(".baja").on("click", function (e) {
        e.preventDefault();
        const target = $(this).attr("href");
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $(target).offset().top
            },
            800
        );
    });

    $(".go-top").click(function () {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: 0
            },
            1000
        );
    });

    $(".js-slider-container").slider();
});

$(document).ready(function () {
    if (($("#loading").fadeOut(), $("#modal-promociones").length)) {
        var t = $;
        var e = function () {
            t("#modal-promociones")
                .find(".promociones")
                .fadeOut(),
                t("#modal-promociones")
                    .find(".selector")
                    .fadeIn();
        },
            n = function () {
                t(".slide-promociones").slick({
                    arrows: !0,
                    autoplay: !1,
                    dots: !1,
                    infinite: !1,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    prevArrow: '<a class="slide-arrow prev-arrow"></a>',
                    nextArrow: '<a class="slide-arrow next-arrow"></a>'
                });
            };
        t("#modal-promociones").modal("show"),
            t("#modal-promociones")
                .find(".ver-promociones")
                .on("click", function (e) {
                    e.preventDefault();
                    var o = t(this).attr("href");
                    t("#modal-promociones")
                        .find(".selector")
                        .fadeOut(),
                        t(o).fadeIn(),
                        t(".slide-promociones").slick("unslick"),
                        n();
                }),
            t("#modal-promociones")
                .find(".volver")
                .on("click", function (t) {
                    t.preventDefault(), e();
                }),
            t("#pegote-promocion").on("click", function (n) {
                n.preventDefault(), e(), t("#modal-promociones").modal("show");
            }),
            n();
    }

    
});
